module.exports = __webpack_public_path__ + "img/Frame-11.736d635a.svg";